import { useState, useEffect, useCallback } from "react";

export const useIdle = (timeout: number = 60000) => {
  const [isIdle, setIsIdle] = useState(false);
  const [lastActive, setLastActive] = useState(Date.now());

  const handleActivity = useCallback(() => {
    setLastActive(Date.now());
    setIsIdle(false);
  }, []);

  useEffect(() => {
    const events = [
      "mousemove",
      "mousedown",
      "keypress",
      "DOMMouseScroll",
      "mousewheel",
      "touchmove",
      "MSPointerMove",
      "click",
    ];

    const throttledHandler = () => {
        // Simple throttle to avoid too many state updates
        if (Date.now() - lastActive > 1000) {
            handleActivity();
        }
    }

    events.forEach((event) => {
      window.addEventListener(event, throttledHandler);
    });

    return () => {
      events.forEach((event) => {
        window.removeEventListener(event, throttledHandler);
      });
    };
  }, [handleActivity, lastActive]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (Date.now() - lastActive >= timeout) {
        setIsIdle(true);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [lastActive, timeout]);

  return { isIdle, lastActive, getLastActiveTime: () => lastActive };
};
